import { GoogleColored } from '@clickcease/cc-client-components-lib'
import React from 'react'

import { MetaColored } from '../../../assets/icons/MetaColored'
import { MicrosoftColored } from '../../../assets/icons/MicrosoftColored'
import { Platforms } from '../../../features/Platforms/models'

export const PlatformIcons = ({
  serviceName,
  iconProps,
}: {
  serviceName: Platforms
  iconProps?: React.SVGProps<SVGSVGElement>
}) => {
  if (serviceName === 'google') {
    return <GoogleColored {...iconProps} />
  } else if (serviceName === 'microsoft') {
    return <MicrosoftColored {...iconProps} />
  } else {
    return <MetaColored {...iconProps} />
  }
}
